export const Routes = {
  HOME: "/",
  PROFILE: "/profile",
  PROFILE_FEEDBACK: "/feedback",
  MY_PRODUCTS: "/my-products",
  ADD_PRODUCTS: "/add-products",
  EDIT_PRODUCT_PATTERN: "/my-products/:id/edit",
  EDIT_PRODUCT: (id: number | string) => `/my-products/${id}/edit`,
} as const;
